(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
var PAGE_HEADER_HEIGHT = 100;
var CONTENT_MARGIN_BOTTOM = 20;
var VERTICAL_OFFSET = PAGE_HEADER_HEIGHT + CONTENT_MARGIN_BOTTOM;

/**
 * Make the static menu float on the left
 */
function floatMenu() {
  var wrap = $(window);
  var menu = $('body');
  var nav = $('#left-sidebar .nav-static');
  var footer = $('.c-footer');

  var offset = 0;


  wrap.scroll(function(e) {
    offset = window.innerHeight - (nav.innerHeight() + VERTICAL_OFFSET);

    if (menu.scrollTop() + wrap.height() > (footer.offset().top + offset)) {
      nav.addClass("nav-fix-bottom");
      nav.removeClass("nav-fix");
    } else if (menu.scrollTop() > 100) {
      nav.addClass("nav-fix");
      nav.removeClass("nav-fix-bottom");
    } else {
      nav.removeClass("nav-fix-bottom");
      nav.removeClass("nav-fix");
    }
  });
}

/**
 * Make additional text apear when the "Read more" button is clicked
 */
function readMore() {
  $('.js-read-more').on('click', function(e) {
    var $target = $('.' + $(e.target).data('target'));

    $target.addClass('visible');

    e.preventDefault();
  });
}

function recruiterPopup() {
  var trigger = $('#recruiter-note-trigger');
  trigger.on('click.popup-trigger', function () {
    var content = $(trigger.attr('data-content')).html();
    $('.modal-content').html(content);

    $("#pamh_modal").modal({
      show: true
    });
  });
}

$(function(){
  floatMenu();
  readMore();
  if ($('#recruiter-note-trigger').length > 0) {
    recruiterPopup();
  }
});

},{}]},{},[1]);
